module.exports = __webpack_public_path__ + "6571c33dfabe00aacaf9a25e29d1113a.pdf";